// extracted by mini-css-extract-plugin
export default {"clear":"styles_clear__kwIH3"};